<template>
    <div>
        <!-- Recipient type is marked as "AR" for AR invoices entry -->
        <div v-if="this.recipientType === 'AR'">
            <div v-for="(email, index) in principals">
                <div v-if="(timeEntry.invoiceId && email.invoices !== null && email.invoices.includes(timeEntry.invoiceId)) || timeEntry.activityCode === $acConstants('EMAIL_REPORT')" class="form-group">
                    <label class="col-sm-2 control-label">{{ email.email !== 'adhoc' ? 'To:' : 'Cc:' }}</label>
                    <div class="col-sm-8 col-md-6">
                        <div :class="{'input-group' : email.companyType === 'Insurer' }">
                            <span class="input-group-addon" v-if="email.companyType === 'Insurer'">
                                <input type="checkbox" :value="index" v-model="timeEntry.emailToCheckboxes"
                                       :disabled="email.missingContact || email.missingEmail || timeEntry.isAuditEdit" />
                            </span>
                            <span v-if="email.email !== 'adhoc'">
                                <input type="text"
                                       class="form-control"
                                       :class="{'invalid-state': email.missingContact || email.missingEmail}"
                                       :disabled="email.email !== 'adhoc'"
                                       :value="getLabel(email)" />
                            </span>
                            <span v-else>
                                <input v-validate.disable="'emails'"
                                       data-vv-as="adhoc Email"
                                       type="text"
                                       class="form-control"
                                       id="adhocEmail"
                                       name="adhocEmail"
                                       v-model="adhocEmail"
                                       placeholder="Other email or list of emails separated by commas or semicolons"
                                       :disabled="timeEntry.isAuditEdit" />
                            </span>
                        </div>
                        <p class="text-danger" v-if="errors.has('adhocEmail') && email.email === 'adhoc'">{{ errors.first('adhocEmail') }}</p>
                        <p class="text-danger" v-if="errors.has('emailTo') && email.email !== 'adhoc'">{{ errors.first('emailTo') }}</p>
                    </div>
                    <div class="col-sm-1 email-to-action" v-if="email.email !== 'adhoc'">
                        <a class="btn btn-link" @click="pickContact(email.actionUrl)" :disabled="timeEntry.isAuditEdit">{{ email.actionLabel }}</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Broker OR Subscriber OR Self Insured  -->
        <div v-else-if="recipientType === 'PR'">
            <div v-for="(email, index) in principals">
                <div v-if="email.email !== 'adhoc'" class="form-group">
                    <label class="col-sm-2 control-label">To:</label>
                    <div class="col-sm-8 col-md-6">
                        <div :class="{'input-group' : principalCount > 1 }">
                            <span class="input-group-addon" v-if="principalCount > 1">
                                <input type="checkbox" :value="index" v-model="timeEntry.emailToCheckboxes"
                                       :disabled="email.missingContact || email.missingEmail || timeEntry.isAuditEdit" />
                            </span>
                            <input type="text"
                                   class="form-control"
                                   :class="{'invalid-state': email.missingContact || email.missingEmail}"
                                   disabled="disabled"
                                   :value="getLabel(email)" />
                        </div>
                        <p class="text-danger" v-if="errors.has('emailTo') && index == principalCount - 1">{{ errors.first('emailTo') }}</p>
                    </div>
                    <div class="col-sm-1 email-to-action">
                        <a class="btn btn-link" @click="pickContact(email.actionUrl)" :disabled="timeEntry.isAuditEdit">{{ email.actionLabel }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="recipientType ==='B'">
            <div v-for="(email, index) in brokers" class="form-group">
                <label class="col-sm-2 control-label">To:</label>
                <div class="col-sm-8 col-md-6">
                    <input type="text"
                           class="form-control"
                           :class="{'invalid-state': email.missingContact || email.missingEmail}"
                           disabled="disabled"
                           :value="getLabel(email)" />
                    <p class="text-danger" v-if="errors.has('emailTo')">{{ errors.first('emailTo') }}</p>
                </div>
                <div class="col-sm-1 email-to-action">
                    <a class="btn btn-link" @click="pickContact(email.actionUrl)" :disabled="timeEntry.isAuditEdit">{{ email.actionLabel }}</a>
                </div>
            </div>
        </div>

        <!-- OTHERS (Not Broker OR Subscriber OR Self Insured)  -->
        <div v-else class="form-group" :class="{'has-error': errors.has('emailTo')}">

            <label for="emailTo" class="col-sm-2 control-label">To:</label>
            <div class="col-sm-8 col-md-6">
                <input v-validate.disable="'required|email'"
                       data-vv-as="to"
                       type="text"
                       class="form-control"
                       id="emailTo"
                       name="emailTo"
                       v-model="timeEntry.emailTo"
                       placeholder="Who is this email to?" 
                       :disabled="timeEntry.isAuditEdit" />
                <p class="text-danger" v-if="errors.has('emailTo')">{{ errors.first('emailTo') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import axios from 'axios';
    import _ from "lodash";

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
                claimEmails: [],
                adhocEmail: null
            };
        },
        methods: {
            getLabel(email) {

                if (email.missingContact && email.companyName !== "") {
                    return "Missing Contact at " + email.companyName;
                }

                if (email.missingContact) {
                    return "Missing Contact";
                }

                return (email.missingEmail ? 'Missing Email Address' : email.email) + (this.timeEntry.activityCode === 'AR' ? '' : ' - ' + email.contactName + ' at ' + email.companyName);
            },
            pickContact(url) {
                this.$emit('contactPickerClick', url)
            }
        },
        computed: {
            principals() {
                return _.filter(this.claimEmails, function (o) {
                    return o.companyType === "SelfInsured" || o.companyType === "Insurer";
                });
            },
            brokers() {
                return _.filter(this.claimEmails, function (o) {
                    return o.companyType === "Broker";
                });
            },
            recipientType() {
                var code = this.timeEntry.activityCode;
                if (!code) {
                    return "O";
                }
                if (code.trim() === "AR" || code.trim() === this.$acConstants('EMAIL_REPORT')) {
                    return "AR";
                }
                if (code.trim() === "ETP") {
                    return "PR";
                }
                return code.charAt(code.length - 1).toUpperCase();
            },
            principalCount() {
                return _.sumBy(this.claimEmails, function (o) {
                    return o.companyType === "SelfInsured" || o.companyType === "Insurer" ? 1 : 0;
                });
            }
        },
        created() {
            let self = this;
            let branchId = this.$store.state.branchId;
            let fileId = this.$store.state.fileId;
            axios.get(`/core/api/claims/${branchId}/${fileId}/emails`)
                .then(response => {
                    self.claimEmails = response.data;

                    // Initialize emailToCheckboxes if it doesn't exist or is empty
                    if (!self.$store.state.timeEntry.emailToCheckboxes) {
                        self.$store.state.timeEntry.emailToCheckboxes = [];
                    }

                    // Only initialize checkboxes if the array is empty (new entry)
                    // Don't add to existing array (coming from edit mode)
                    if (self.$store.state.timeEntry.emailToCheckboxes.length === 0) {
                        self.claimEmails.forEach(function (email, index) {
                            if (!email.missingContact && !email.missingEmail && email.companyType !== "Broker" && email.email !== 'adhoc') {
                                self.$store.state.timeEntry.emailToCheckboxes.push(index);
                            }
                        });
                    }
                });
        },
        updated() {
            if (this.recipientType === "PR" || this.recipientType === "AR") {
                this.$store.state.timeEntry.emailTo = "";
                var self = this;
                let emails = [];
                let invoiceId = self.$store.state.timeEntry.invoiceId;
                let isMultiInvoice = self.$store.state.timeEntry.isMultiInvoice;
                let isSameSubscriberInvoices = self.$store.state.timeEntry.isSameSubscriberInvoices;
                // Find the index of the adhoc email in the principals array
                const adhocIndex = this.principals.findIndex(email => email.email === 'adhoc');
                let subscriberCount = self.$store.state.timeEntry.emailToCheckboxes.length - (this.timeEntry.emailToCheckboxes.includes(adhocIndex) ? 1 : 0);
                let nextReportNumber = self.$store.state.lastReportNumber + 1;

                this.claimEmails.forEach(function (email, index) {
                    if (self.recipientType === "AR") {
                        if (self.timeEntry.activityCode === 'AR' && invoiceId != null && email.invoices !== null && email.invoices.includes(invoiceId) && email.email !== 'adhoc') {
                            // RE is a max of 100 characters, cut off insured if too long
                            let InsSubjLength = 100 - ((isSameSubscriberInvoices ? "Your Claim#: " + email.claimNumber + "; " : "") + "Insured: " +
                                "; KA File#: " + self.$store.state.timeEntry.fileId + "; " +
                                (isMultiInvoice ? "Overdue KA Invoices" : "Overdue KA Invoice#: " + invoiceId)).length;
                            self.$store.state.timeEntry.comment = (isSameSubscriberInvoices ? "Your Claim#: " + email.claimNumber + "; " : "") +
                                "Insured: " + self.$store.state.timeEntry.insuredCompany.substring(0, InsSubjLength) +
                                "; KA File#: " + self.$store.state.timeEntry.fileId + "; " +
                                (isMultiInvoice ? "Overdue KA Invoices" : "Overdue KA Invoice#: " + invoiceId);
                            self.$store.state.claimNumber = (isSameSubscriberInvoices ? email.claimNumber : null);
                        }
                        else if (self.timeEntry.activityCode === self.$acConstants('EMAIL_REPORT') && email.email && email.email !== 'adhoc' && email.companyType !== 'Broker') {
                            // RE is a max of 100 characters, cut off insured if too long
                            let InsSubjLength = 100 - ("Report#: " + nextReportNumber + "; " + (subscriberCount > 1 ? "" : "Your Claim#: " + email.claimNumber + "; ") + "Insured: " +
                                "; KA File#: " + self.$store.state.timeEntry.fileId).length;
                            self.$store.state.timeEntry.comment = ("Report#: " + nextReportNumber + "; " + (subscriberCount > 1 ? "" : "Your Claim#: " + email.claimNumber + "; ") +
                                "Insured: " + self.$store.state.timeEntry.insuredCompany.substring(0, InsSubjLength) +
                                "; KA File#: " + self.$store.state.timeEntry.fileId);
                            self.$store.state.claimNumber = (subscriberCount > 1 ? null : email.claimNumber);
                        }
                        if (!email.missingContact && !email.missingEmail && email.companyType !== "Broker" &&
                            (self.timeEntry.activityCode !== 'AR' || (invoiceId && email.invoices !== null && email.invoices.includes(invoiceId)))) {
                            if (_.includes(self.$store.state.timeEntry.emailToCheckboxes, index)) {
                                emails.push(email.email === 'adhoc' ? self.adhocEmail : email.email);
                            }
                        }
                    }
                    else if (self.$store.state.timeEntry.emailToCheckboxes && _.includes(self.$store.state.timeEntry.emailToCheckboxes, index) &&
                        !email.missingContact && !email.missingEmail && email.companyType !== "Broker" && email.email != "adhoc") {
                        emails.push(email.email);
                    }
                });
                this.$store.state.timeEntry.emailTo =
                    _.uniq(emails)
                        .filter(x => x && x.trim() !== '')
                        .join('; ');

            } else if (this.recipientType === "B") {
                this.$store.state.timeEntry.emailTo = this.brokers[0].email;
            }
        }
    };
</script>

<style>
    select.invalid-state,
    input.invalid-state {
        color: #a94442;
        background-color: #fff6f6;
        border: 1px solid #ebccd1;
    }

</style>